import React, { useState, useEffect, useContext } from "react";
import Banner from "../../components/Banner/Banner";
import Pagination from "../../components/pageProps/shopPage/Pagination";
import { UserConfigContext } from "../../context/UserConfigContext";
import { useLocation } from "react-router-dom";
import posterImg from "../../assets/images/logo_hinet.jpeg";

const Home = () => {
  const { config1, config2 } = useContext(UserConfigContext);
  const [showMore, setShowMore] = useState(false);
  const [videoReady, setVideoReady] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const verMas = sessionStorage.getItem("verMas") === "true";
    setShowMore(verMas);
  }, [location]);

  const imageCategories = Array.isArray(config1?.cuadrante)
    ? config1.cuadrante.map((cuadra) => ({
        href: cuadra.url_destino || "#",
        imgSrc: cuadra.rutaimagen || "",
        alt: cuadra.grupo_nombre || "Sin nombre",
      }))
    : [];

  return (
    <div className="w-full mx-auto">
      {config2.vista.carousel_home === 1 && !showMore && <Banner />}

      {config2.vista.muestra_cuadrante === 1 &&
        imageCategories.length === 4 &&
        !showMore && (
          <section className="section-category section-category--desktop section-category--standard my-8 max-h-[600px] overflow-hidden">
            <div className="max-w-[1200px] mx-auto px-4 flex gap-x-4 h-full">
              <div className="flex-1 flex flex-col justify-between gap-y-4 h-full">
                {imageCategories.slice(0, 2).map(({ href, imgSrc, alt }, i) => {
                  const isVimeo = imgSrc.includes("vimeo.com");
                  const isVideoFile = /\.(mp4|webm|ogg)$/i.test(imgSrc);

                  return (
                    <a
                      key={i}
                      href={href}
                      target="_self"
                      rel="noopener noreferrer"
                      className="block w-full"
                    >
                      <div className="w-full relative overflow-hidden rounded-none aspect-video group">
                        {!videoReady && (
                          <img
                            src={posterImg}
                            alt={alt}
                            className="absolute inset-0 w-full h-full object-cover rounded-md z-10"
                          />
                        )}

                        {isVimeo ? (
                          <iframe
                            title={alt}
                            src={`${imgSrc}?title=0&byline=0&portrait=0&autopause=0&autoplay=1&loop=1&muted=1&background=1`}
                            allow="autoplay; fullscreen"
                            allowFullScreen
                            className="absolute inset-0 w-full h-full object-cover border-0 rounded-md"
                            onLoad={() => setVideoReady(true)}
                          />
                        ) : isVideoFile ? (
                          <video
                            src={imgSrc}
                            autoPlay
                            loop
                            muted
                            playsInline
                            className="absolute inset-0 w-full h-full object-cover rounded-md"
                            onLoadedData={() => setVideoReady(true)}
                          />
                        ) : (
                          <img
                            decoding="async"
                            src={imgSrc}
                            alt={alt}
                            className="absolute inset-0 w-full h-full object-cover rounded-md"
                          />
                        )}

                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-300 object-cover rounded-md" />
                      </div>
                    </a>
                  );
                })}
              </div>

              <div className="flex-1 flex flex-col justify-between gap-y-4 h-full">
                {imageCategories.slice(2, 4).map(({ href, imgSrc, alt }, i) => {
                  const isVimeo = imgSrc.includes("vimeo.com");
                  const isVideoFile = /\.(mp4|webm|ogg)$/i.test(imgSrc);

                  return (
                    <a
                      key={i + 2}
                      href={href}
                      target="_self"
                      rel="noopener noreferrer"
                      className="block w-full"
                    >
                      <div className="w-full relative overflow-hidden rounded-none aspect-video group">
                        {!videoReady && (
                          <img
                            src={posterImg}
                            alt={alt}
                            className="absolute inset-0 w-full h-full object-cover rounded-md z-10"
                          />
                        )}

                        {isVimeo ? (
                          <iframe
                            title={alt}
                            src={`${imgSrc}?title=0&byline=0&portrait=0&autopause=0&autoplay=1&loop=1&muted=1&background=1`}
                            allow="autoplay; fullscreen"
                            allowFullScreen
                            className="absolute inset-0 w-full h-full object-cover border-0 rounded-md"
                            onLoad={() => setVideoReady(true)}
                          />
                        ) : isVideoFile ? (
                          <video
                            src={imgSrc}
                            autoPlay
                            loop
                            muted
                            playsInline
                            className="absolute inset-0 w-full h-full object-cover rounded-md"
                            onLoadedData={() => setVideoReady(true)}
                          />
                        ) : (
                          <img
                            decoding="async"
                            src={imgSrc}
                            alt={alt}
                            className="absolute inset-0 w-full h-full object-cover rounded-md"
                          />
                        )}

                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-300 object-cover rounded-md" />
                      </div>
                    </a>
                  );
                })}
              </div>
            </div>
          </section>
        )}

      <div className="max-w-container mx-auto px-4">
        <div className="w-full h-full flex pb-20 gap-10">
          <div className="w-full h-full flex flex-col gap-10 mt-3">
            <Pagination />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
